import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule, MatCheckboxModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSnackBarModule, MatTableModule } from "@angular/material";
import { NgxSpinnerModule } from "ngx-spinner";
import { VkUsersModalComponent } from "./components/modal/vk-users.modal";
import { VkUsersComponent } from "./components/vk-users.component";



@NgModule({
  declarations: [
    VkUsersComponent,
    VkUsersModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCheckboxModule,
    NgxSpinnerModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  exports: [
    VkUsersComponent,
    VkUsersModalComponent
  ],
  entryComponents: [
    VkUsersModalComponent
  ]
})
export class VkUsersModule { }
